import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';

/**
 * Timbra "Pag. i di N" in basso al centro su ogni pagina di un PDF react-pdf,
 * perché il footer `fixed` di react-pdf non è affidabile. Non tocca le ancore
 * firma a destra. In caso di errore ritorna il PDF originale.
 */
export async function stampInformativaPageNumbers(blob: Blob): Promise<Blob> {
    try {
        const doc = await PDFDocument.load(await blob.arrayBuffer(), { ignoreEncryption: true });
        const font = await doc.embedFont(StandardFonts.Helvetica);
        const pages = doc.getPages();
        const total = pages.length;
        const grey = rgb(0.533, 0.533, 0.533); // #888888
        pages.forEach((page, i) => {
            const { width } = page.getSize();
            page.drawRectangle({ x: width * 0.30, y: 3, width: width * 0.40, height: 17, color: rgb(1, 1, 1) });
            const label = `Pag. ${i + 1} di ${total}`;
            const size = 8;
            const tw = font.widthOfTextAtSize(label, size);
            page.drawText(label, { x: (width - tw) / 2, y: 8, size, font, color: grey });
        });
        const out = await doc.save();
        return new Blob([out], { type: 'application/pdf' });
    } catch (e) {
        return blob;
    }
}
